import React, { Component } from 'react';
import styles from './SpeechBubble.module.scss'

export class SpeechBubble extends Component {
    static displayName = SpeechBubble.name;

    onTap = (e) => {
        this.anchor.click();        
    };

    render() {
        return (
            <div onClick={this.props.tapText && this.props.tapUrl ? this.onTap : null} className={`${styles.bubble} ${this.props.className || ""}`}>                
                <div className={`inner ${this.props.isProposed ? "proposed" : "agreed"}`}>                    
                    {this.props.content ? 
                        this.props.content :
                        this.props.children ? this.props.children : <span className="small">{this.props.text}</span>
                    }
                    {this.props.tapText && this.props.tapUrl &&
                        <>
                        <br />{this.props.tapIcon && <><img src={this.props.tapIcon} /></>}
                        <a ref={a => this.anchor = a} target="_blank" onClick={e => e.stopPropagation()} href={this.props.tapUrl}>{this.props.tapText}</a>
                        </>}
                </div>
                <i className="icon-arrow-down"></i>
            </div>
        );
    }
}